var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4269 0.930176H3.81899C2.22327 0.930176 0.929688 2.22376 0.929688 3.81948V20.3673C0.929688 21.963 2.22327 23.2566 3.81899 23.2566H16.4269C18.0226 23.2566 19.3162 21.963 19.3162 20.3673V3.81948C19.3162 2.22376 18.0226 0.930176 16.4269 0.930176Z",
    stroke: "black",
    strokeWidth: 1.86054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1244 5.52783V14.7211M4.87109 10.1244H15.3776M4.87109 5.52783H15.3776V14.7211H4.87109V5.52783Z",
    stroke: "black",
    strokeWidth: 1.86054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6327 19.9729C16.2129 19.9729 16.6833 19.5025 16.6833 18.9222C16.6833 18.342 16.2129 17.8716 15.6327 17.8716C15.0524 17.8716 14.582 18.342 14.582 18.9222C14.582 19.5025 15.0524 19.9729 15.6327 19.9729Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.916cc633fc9b92bb38bb7bcbfb9f162a.svg";
export { ForwardRef as ReactComponent };